import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="w-full py-8 md:py-14 px-4 bg-[#FDF6F0]" data-id="element-60">
      <div className="max-w-4xl mx-auto text-center" data-id="element-61">
        <motion.div initial={{
        opacity: 0,
        scale: 0.5
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="flex justify-center mb-4 md:mb-6" data-id="element-62">
          <ShieldCheck className="w-24 h-24 text-brand-gold" data-id="element-63" />
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl font-bold text-brand-text-primary mb-4 md:mb-6" data-id="element-64">
          Tu Inversión Está 100% Protegida
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-lg text-brand-text-body leading-relaxed max-w-2xl mx-auto" data-id="element-65">
          Probá CÓDIGO HORMONAL por 7 días completos. Si no sentís ningún cambio
          en tu energía, digestión o relación con tu cuerpo, te devolvemos el
          100% de tu dinero. Sin formularios. Sin excusas. Sin preguntas. El
          riesgo es nuestro. El resultado es tuyo.
        </motion.p>
      </div>
    </section>;
}